import React from 'react';
import StaticPageLayout from '../components/StaticPageLayout';

const CRITERIA = [
  { title: 'Scientific Rigour & Validity', weight: 'Critical', desc: 'The research methodology must be sound, reproducible where applicable, and clearly described. Results must be logically interpreted and conclusions supported by the data presented.' },
  { title: 'Originality & Contribution', weight: 'Critical', desc: 'The work must present a meaningful and original contribution to the field. Incremental improvements may be accepted if clearly positioned within the existing body of literature.' },
  { title: 'Clarity of Presentation', weight: 'High', desc: 'The manuscript must be written clearly and concisely in professional English. Logical structure, coherent argumentation, and well-presented figures and tables are expected.' },
  { title: 'Literature Review & Context', weight: 'High', desc: 'Authors must adequately situate their work within the existing literature, citing relevant prior work accurately and honestly.' },
  { title: 'Data Accuracy & Integrity', weight: 'Critical', desc: 'All data must be accurately reported. Fabrication, falsification, or selective reporting of data constitutes research misconduct and will result in rejection and potential formal reporting.' },
  { title: 'Ethical Compliance', weight: 'Critical', desc: 'Research involving human or animal subjects must demonstrate appropriate ethical approvals. The manuscript must disclose funding sources, conflicts of interest, and any relevant ethical considerations.' },
];

const ReviewCriteriaPage = () => (
  <StaticPageLayout
    overline="Submission Policies"
    title="Review Criteria"
    description="Manuscripts submitted to MAH Quantum Research Institute are evaluated against a defined set of academic and methodological standards. Understanding these criteria will help authors prepare stronger submissions."
    breadcrumbs={[{ label: 'Submission Policies', path: '/submission-process' }, { label: 'Review Criteria', path: '/review-criteria' }]}
  >
    <div className="space-y-10">
      <section>
        <h2 className="font-serif text-2xl font-semibold text-[#1F1F1F] mb-5 pb-3 border-b border-[#E5E7EB]">Evaluation Criteria</h2>
        <div className="space-y-3">
          {CRITERIA.map(item => (
            <div key={item.title} className="border border-[#E5E7EB] p-5 bg-white">
              <div className="flex items-start justify-between gap-3 mb-2">
                <h3 className="font-semibold text-[#1F1F1F] text-sm">{item.title}</h3>
                <span className={`text-xs px-2 py-0.5 border font-medium flex-shrink-0 ${item.weight === 'Critical' ? 'bg-red-50 text-red-700 border-red-200' : 'bg-amber-50 text-amber-700 border-amber-200'}`}>
                  {item.weight}
                </span>
              </div>
              <p className="text-sm text-[#6B7280] leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section>
        <h2 className="font-serif text-2xl font-semibold text-[#1F1F1F] mb-4 pb-3 border-b border-[#E5E7EB]">Overall Assessment Scale</h2>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
          {[
            { verdict: 'Accept', desc: 'Meets all criteria; publication recommended', color: 'bg-green-50 border-green-200 text-green-700' },
            { verdict: 'Minor Revision', desc: 'Minor improvements required before acceptance', color: 'bg-blue-50 border-blue-200 text-blue-700' },
            { verdict: 'Major Revision', desc: 'Substantial revisions needed; second review required', color: 'bg-amber-50 border-amber-200 text-amber-700' },
            { verdict: 'Reject', desc: 'Does not meet publication standards', color: 'bg-red-50 border-red-200 text-red-700' },
          ].map(item => (
            <div key={item.verdict} className={`border px-4 py-3 ${item.color}`}>
              <p className="font-semibold text-sm mb-1">{item.verdict}</p>
              <p className="text-xs leading-relaxed opacity-80">{item.desc}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  </StaticPageLayout>
);

export default ReviewCriteriaPage;
